// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/component/element/NumericFormat.css
// module id = 1998
// module chunks = 0